import { render, staticRenderFns } from "./QbTd.vue?vue&type=template&id=5947bb04"
import script from "./QbTd.vue?vue&type=script&lang=js"
export * from "./QbTd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports